// extracted by mini-css-extract-plugin
export default {"back_icon":"BackIcon_back_icon__gsFaF"};